/* components/SearchFullScreen
- Used within collection and search templates
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class SearchFullScreen extends ThemeComponent {
    @Ref() klevuSearch!: HTMLInputElement;

    init() {
        const inputFocus = this.querySelector('.js-klevu-search') as HTMLInputElement;

        const observer = new MutationObserver(() => {
            // Delay until css transition is completed at 0.9s
            setTimeout(function() {
                inputFocus.focus();
            }, 1000);
        });

        const config = { attributes: true };

        observer.observe(this, config);
    }
}
